module.exports = __webpack_public_path__ + "assets/facebook_logo_white.fd8724588748cad71c09776b2ce95509.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/facebook_logo_white.png
 ** module id = 180
 ** module chunks = 0
 **/